import {Record} from 'immutable';
import {identity} from 'rxjs';

import {type AutomaticBillingDate} from 'web-app/util/graphql/api-types';
import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export class AutomaticPaymentsModalState extends Record<{
    readonly isVisible: boolean;
    readonly institutionSetId?: string;
    readonly paymentsAccountId?: string;
    readonly isAutomaticPaymentsByDefault?: boolean;
    readonly nextAutomaticPaymentDate?: string;
    readonly setNextAutomaticPayments: (date: Array<string> | null) => void;
    readonly setAutomaticBillingDate: (automaticBillingDate: AutomaticBillingDate | null) => void;
    readonly canUseExactDayOfWeek: boolean;
}>({
    isVisible: false,
    institutionSetId: undefined,
    paymentsAccountId: undefined,
    isAutomaticPaymentsByDefault: false,
    nextAutomaticPaymentDate: undefined,
    setNextAutomaticPayments: identity,
    setAutomaticBillingDate: identity,
    canUseExactDayOfWeek: false,
}) {}

export default makeReducer<AutomaticPaymentsModalState>(
    [
        match(Actions.show, (state, {payload}) =>
            state.merge({
                isVisible: true,
                institutionSetId: payload.institutionSetId,
                paymentsAccountId: payload.paymentsAccountId,
                isAutomaticPaymentsByDefault: payload.isAutomaticPaymentsByDefault,
                nextAutomaticPaymentDate: payload.nextAutomaticPaymentDate,
                setNextAutomaticPayments: payload.setNextAutomaticPayments,
                setAutomaticBillingDate: payload.setAutomaticBillingDate,
                canUseExactDayOfWeek: payload.canUseExactDayOfWeek,
            }),
        ),
        match(Actions.hide, state =>
            state.merge({
                isVisible: false,
            }),
        ),
    ],
    new AutomaticPaymentsModalState(),
);
